import React from "react";
import { useState, useEffect } from "react";
import loader from "../../../../assets/images/menu-icon/loader.gif";
import { TbDownload } from "react-icons/tb";
import WebService, { BASE_URL } from "../../../../utility/WebService";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import Loader from "../../../../components/Loader/Loader";
import Pagination from "../../../../components/pagination/Pagination";
import HelperService from "../../../../utility/HelperService";
import { useNavigate } from "react-router-dom";
import AlertModal from "../../../../components/AlertComponent/Alert";

const CompletedAgreement = () => {
    const [showLoader, setShowLoader] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const [agreement, setAgreement] = useState<any[]>([]);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    const [isShoWDeleteModal, setShowDeleteModal] = useState(false);
    const [clientId, setClientId] = useState<any>();
    const [clientName, setClientName] = useState('');
    let history = useNavigate();

    useEffect(() => {
        getList(1);
    }, []);

    const getList = (page: Number) => {
        setShowLoader(true)
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementList` : `/v2/ClientAgreements/GetClientAgreementList`}?page=${page}&status=COMPLETED&keyword=${searchText}`,
            body: null
        })
            .then((res: any) => {
                setShowLoader(false)
                setAgreement(res.list)
                setTotalCount(res.total_count)
            })
            .catch((e) => {
                setShowLoader(false)
            })
    };

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DownloadFinalDocument?id=${id}`)
        setShowLoader(false)
    }

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }
    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }
    const closeModal = () => {
        setShowDeleteModal(false);
        setShowLoader(false);
    };
    const goToRenewalPage =()=>{
        history(`/admin/mis-report/renew-agreement/${clientId}`, {
            state: {
                name: clientName
            }
        });
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <AlertModal
                show={isShoWDeleteModal}
                isClose={closeModal}
                delete={goToRenewalPage}
                data={clientId}
                message={'Are you sure want to renew Agreement?'}
                button1={'Yes'}
                button2={'No'}
            />
            <Loader show={showLoader} />
            <div className="page-content-wraper">
                <div className="table-card">
                    <div className=" grid grid-cols-12 filter-wrap mb-3">
                        <div className="flex col-span-5">
                            <div className="w-full max-w-lg lg:max-w-xs mr-3 ">
                                <label htmlFor="search" className="sr-only">Search</label>
                                <div className="relative w-64">
                                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <input id="search" name="search" className="block w-full table-search-filter" placeholder="Search" type="search" value={searchText} onChange={(e) => setSearchText(e.target.value)} onKeyUp={(e) => {
                                        if (e.keyCode === 13) {
                                            getList(1)
                                        }
                                    }} />
                                </div>
                            </div>

                        </div>
                    </div>
                    <table className="table-style-list">
                        <thead>
                            <tr>
                                <th>Client Name</th>
                                <th>Agreement Type</th>
                                <th>Client Ip</th>
                                <th>Client Signed Date</th>
                                <th>Advisor Signed Date</th>
                                <th>Agreement Start Date</th>
                                <th>Agreement End Date</th>
                                <th>Date</th>
                                <th className='text-center'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                agreement.length > 0 && agreement.map((res) => {
                                    return (
                                        <tr className="5097 odd" role="row">
                                            <td className="align-left">{res.client_name ? res.client_name : "-"}</td>
                                            <td className="align-left">{res.agreement_type === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
                                                    res.agreement_type === 'E_SIGN' ? 'Wet Sign' :
                                                    res.agreement_type === 'SCANED_BY_BOTH' ? 'Physical' :
                                                    "-"}</td>
                                            <td className="align-left">{res.ip_client ? res.ip_client : "-"}</td>
                                            <td className="align-left">{res.client_signed_date ? HelperService.getFormatedDateAndTime(res.client_signed_date) : "-"}</td>
                                            <td className="align-left">{res.advisor_signed_date ? HelperService.getFormatedDateAndTime(res.advisor_signed_date) : "-"}</td>
                                            <td className="align-left">{res.start_date ? HelperService.getFormatedDateByDMY(res.start_date) : "-"}</td>
                                            <td className="align-left">{res.end_date ? HelperService.getFormatedDateByDMY(res.end_date) : "Perpetual"}</td>
                                            <td className="align-left">{res.created_at ? HelperService.getFormatedDateByDMY(res.created_at) : "-"}</td>
                                            <td className='text-center' >
                                                <a href="javascript:void(0)" className="action-btn" title="Download">
                                                    <TbDownload size={20} className="mr-3 text-brand" onClick={() => download(res.id)} />
                                                </a>
                                                {user_data.is_person == 'Employee' &&
                                                <>
                                                    <button type="button" className="btn btn-brand mr-3" onClick={() => {setShowDeleteModal(true)
                                                        setClientId(res.client_id)
                                                        setClientName(res.client_name);
                                                        }}
                                                        disabled={res.is_disabled}
                                                        // style={{cursor: res.is_disabled ? 'not-allowed' : ''}}
                                                        >
                                                        Renew </button>
                                                         <a onClick={() => history(`/admin/mis-report/edit-agreement/${res.client_id}/${res.id}`, {
                                                                state: {
                                                                    name: res.client_name
                                                                }
                                                            })} href="javascript:void(0)" className="action-btn" title="Edit">
                                                                <svg className="icon inline mr-2" width={18} height={18} >
                                                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#edit"></use>
                                                                </svg>
                                                            </a>
                                                        </>
                                                        }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {
                        agreement.length == 0 && showLoader == false &&
                        <div>
                            <div className="error-message-table">No Records Found</div>
                        </div>
                    }
                    {
                        showLoader &&
                        <div style={{ textAlign: "center", marginTop: "10%" }}>
                            <img
                                style={{ position: "relative" }}
                                src={loader}
                                alt="No loader found"
                            />
                            <div style={{ position: "relative", color: "white" }}>
                                Loading...
                            </div>
                        </div>
                    }
                    {
                        totalCount > 0 &&
                        <div className="d-flex flex-row justify-content-between pb-3 align-items-center pagination-row">
                            <div className="d-flex col-6 align-items-center">
                                <Pagination
                                    className=" "
                                    changePage={(page: number) => {
                                        setCurrentPage(page);
                                        getList(page);
                                    }}
                                    totalItems={totalCount}
                                    itemsCountPerPage={10}
                                    changeCurrentPage={currentPage}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>

        </>
    )
}
export default CompletedAgreement;